/**
 * Returns irregular participles for Dutch.
 *
 * @returns {string[]} Dutch irregular participles.
 */
export default [
	"aaneengedraaid",
	"aaneengeschakeld",
	"aanschouwd",
	"aanvaard",
	"achtergebleven",
	"achtergelaten",
	"achterhaald",
	"achteromgekeken",
	"achteropgekomen",
	"achteruitgegaan",
	"achtervolgd",
	"ademgehaald",
	"bedolven",
	"bedongen",
	"bedorven",
	"bedragen",
	"bedreven",
	"bedrogen",
	"bedropen",
	"bedwongen",
	"beetgenomen",
	"begeven",
	"begonnen",
	"begraven",
	"begrepen",
	"behangen",
	"behouden",
	"bekeken",
	"beklommen",
	"bekomen",
	"bekropen",
	"beleden",
	"belezen",
	"benomen",
	"beraden",
	"beschenen",
	"beschoten",
	"beschreven",
	"beslagen",
	"beslopen",
	"besloten",
	"besneden",
	"besproken",
	"besprongen",
	"bestegen",
	"bestolen",
	"bestorven",
	"bestreden",
	"bestreken",
	"betreden",
	"betroffen",
	"betrokken",
	"bevallen",
	"bevochten",
	"bevolen",
	"bevonden",
	"bevroren",
	"bewezen",
	"bewogen",
	"bezeten",
	"bezien",
	"beziggehouden",
	"bezonnen",
	"bezweken",
	"bezworen",
	"bijeengehouden",
	"bijeengeroepen",
	"blootgelegd",
	"blootgesteld",
	"bovengehaald",
	"brandgesticht",
	"buitengesloten",
	"buitgemaakt",
	"deelgenomen",
	"dichtgebonden",
	"dichtgedaan",
	"diepgevroren",
	"doodgegaan",
	"doorbladerd",
	"doorboord",
	"doorbroken",
	"doordacht",
	"doordrongen",
	"doorgrond",
	"doorkruist",
	"doorlopen",
	"doorsneden",
	"doorstaan",
	"doorverteld",
	"doorzien",
	"doorzocht",
	"drooggelegd",
	"dwarsgezeten",
	"ervaren",
	"flauwgevallen",
	"gebakken",
	"gebannen",
	"gebarsten",
	"gebeden",
	"gebersten",
	"gebeten",
	"geblazen",
	"gebleken",
	"gebleven",
	"geblonken",
	"geboden",
	"gebogen",
	"gebonden",
	"geboren",
	"geborgen",
	"geborsten",
	"gebraden",
	"gebroken",
	"gebrouwen",
	"gedaan",
	"gedoken",
	"gedolven",
	"gedongen",
	"gedragen",
	"gedreten",
	"gedreven",
	"gedrongen",
	"gedronken",
	"gedropen",
	"gedwongen",
	"gefloten",
	"gegeten",
	"gegeven",
	"gegleden",
	"geglommen",
	"gegolden",
	"gegoten",
	"gegraven",
	"gegrepen",
	"gehangen",
	"gehesen",
	"geheven",
	"geholpen",
	"gehouden",
	"gehouwen",
	"gekeken",
	"geklommen",
	"geklonken",
	"gekloven",
	"geknepen",
	"gekomen",
	"gekorven",
	"gekozen",
	"gekregen",
	"gekresen",
	"gekreten",
	"gekrompen",
	"gekrooien",
	"gekropen",
	"gekunnen",
	"gekweten",
	"gelachen",
	"geladen",
	"gelaten",
	"geleden",
	"gelegen",
	"geleken",
	"gelezen",
	"gelogen",
	"geloken",
	"gelopen",
	"gemalen",
	"gemeden",
	"gemeten",
	"gemoeten",
	"gemogen",
	"gemolken",
	"genegen",
	"genezen",
	"genomen",
	"genoten",
	"geprezen",
	"geraden",
	"gereden",
	"geregen",
	"gereten",
	"gerezen",
	"geroepen",
	"geroken",
	"geschapen",
	"gescheiden",
	"geschenen",
	"gescheten",
	"gescholden",
	"gescholen",
	"geschonden",
	"geschonken",
	"geschoren",
	"geschoten",
	"geschoven",
	"geschreden",
	"geschreven",
	"geschrokken",
	"geslagen",
	"geslapen",
	"geslepen",
	"gesleten",
	"geslonken",
	"geslopen",
	"gesloten",
	"gesmeten",
	"gesmolten",
	"gesneden",
	"gesnoten",
	"gesnoven",
	"gespannen",
	"gespeten",
	"gespleten",
	"gesponnen",
	"gespoten",
	"gesproken",
	"gesprongen",
	"gesproten",
	"gestegen",
	"gestoken",
	"gestolen",
	"gestonken",
	"gestoten",
	"gestoven",
	"gestreden",
	"gestreken",
	"getreden",
	"getroffen",
	"getrokken",
	"gevallen",
	"gevangen",
	"gevangengenomen",
	"gevaren",
	"gevezen",
	"gevlochten",
	"gevloden",
	"gevlogen",
	"gevloten",
	"gevochten",
	"gevonden",
	"gevouwen",
	"gevreten",
	"gevroren",
	"gewassen",
	"geweken",
	"geweten",
	"geweven",
	"gewezen",
	"gewogen",
	"gewonden",
	"gewonnen",
	"geworden",
	"geworpen",
	"geworven",
	"gewoven",
	"gewreten",
	"gewreven",
	"gewrongen",
	"gezegen",
	"gezeken",
	"gezeten",
	"gezien",
	"gezoden",
	"gezogen",
	"gezonden",
	"gezongen",
	"gezonken",
	"gezonnen",
	"gezopen",
	"gezouten",
	"gezwegen",
	"gezwolgen",
	"gezwollen",
	"gezwommen",
	"gezwonden",
	"gezworen",
	"gezworven",
	"hardgelopen",
	"herladen",
	"hernomen",
	"herwonnen",
	"herzien",
	"huisgehouden",
	"kennisgemaakt",
	"klaargekomen",
	"kortgesloten",
	"kwaadgesproken",
	"kwijtgeraakt",
	"kwijtgescholden",
	"langsgekomen",
	"leeggelopen",
	"leeggemaakt",
	"lesgegeven",
	"liefgehad",
	"lipgelezen",
	"meebetaald",
	"misbruikt",
	"misleid",
	"mislukt",
	"misprezen",
	"nabewerkt",
	"nedergedaald",
	"omarmd",
	"omfloerst",
	"omhelsd",
	"omkleed",
	"omklemd",
	"ommuurd",
	"omringd",
	"omschreven",
	"omsingeld",
	"omsloten",
	"omvat",
	"omvergeworpen",
	"omwikkeld",
	"omwonden",
	"omzeild",
	"omzoomd",
	"omzworven",
	"onderbouwd",
	"onderbroken",
	"onderdrukt",
	"ondergaan",
	"ondergraven",
	"onderhandeld",
	"onderhouden",
	"onderkend",
	"ondermijnd",
	"ondernomen",
	"onderscheiden",
	"onderschept",
	"ondersteund",
	"onderstreept",
	"ondertekend",
	"onderverdeeld",
	"ondervonden",
	"ondervraagd",
	"onderwezen",
	"onderworpen",
	"onderzocht",
	"ontbeten",
	"ontboden",
	"ontbonden",
	"ontbroken",
	"ontdoken",
	"ontgonnen",
	"onthouden",
	"ontkomen",
	"ontladen",
	"ontloken",
	"ontlopen",
	"ontnomen",
	"ontraden",
	"ontslagen",
	"ontsloten",
	"ontspannen",
	"ontsprongen",
	"ontsproten",
	"ontstoken",
	"onttrokken",
	"ontvangen",
	"ontweken",
	"schoongemaakt",
	"schoongewassen",
	"stilgestaan",
	"tandengepoetst",
	"tegemoetgekomen",
	"teleurgesteld",
	"teloorgegaan",
	"terechtgekomen",
	"terechtgesteld",
	"teweeggebracht",
	"thuisbezorgd",
	"thuisgekomen",
	"toebehoord",
	"toevertrouwd",
	"tussengekomen",
	"tussengeworpen",
	"uitbesteed",
	"uitbetaald",
	"uitvergroot",
	"uitverkocht",
	"valsgespeeld",
	"verbannen",
	"verbleven",
	"verboden",
	"verbogen",
	"verbonden",
	"verborgen",
	"verbroken",
	"verdragen",
	"verdreven",
	"verdrongen",
	"verdronken",
	"verdroten",
	"verdwenen",
	"vergeleken",
	"vergeten",
	"vergeven",
	"vergleden",
	"vergolden",
	"vergoten",
	"vergrepen",
	"verhangen",
	"verheven",
	"verholpen",
	"verhouden",
	"verkozen",
	"verkregen",
	"verladen",
	"verlaten",
	"verlopen",
	"verloren",
	"vermeden",
	"vermogen",
	"vernomen",
	"verraden",
	"verrezen",
	"verscheiden",
	"verschenen",
	"verscholen",
	"verschoten",
	"verschoven",
	"verschreven",
	"verschrokken",
	"verslagen",
	"verslapen",
	"versleten",
	"verslonden",
	"versmolten",
	"verstoten",
	"verstreken",
	"vertrokken",
	"vervallen",
	"vervangen",
	"vervlogen",
	"verweten",
	"verweven",
	"verwezen",
	"verworpen",
	"verworven",
	"verwrongen",
	"verzonden",
	"verzonken",
	"verzonnen",
	"verzopen",
	"verzouten",
	"verzwonden",
	"volbracht",
	"voldaan",
	"voleindigd",
	"volhard",
	"volmaakt",
	"volstaan",
	"voltooid",
	"voltrokken",
	"voorbehouden",
	"voorkomen",
	"voorspeld",
	"voorzien",
	"wederhaald",
	"weergalmd",
	"weerhouden",
	"weerkaatst",
	"weerlegd",
	"weerstaan",
];

